import echarts from 'echarts'
var option = {
    title: {
        text: '',
        x: 'center',
        y: 0,
        textStyle: {
            color: '#B4B4B4',
            fontSize: 16,
            fontWeight: 'normal'
        }
    },
    tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
    },
    legend: {
        // 修改legend的高度宽度
        itemHeight: 5,
        itemWidth: 24,
        data: [{
            name: '观看人数',
            icon: 'rect' // legend的icon
        },
        {
            name: '总互动量',
            icon: 'rect'
        }
        ],
        textStyle: {
            color: '#B4B4B4'
        },
        top: '0%',
    },
    grid: {
        "left": "70",
        "top": "30",
        "right": "70",
        "bottom": "40"
    },
    xAxis: [{
        // type:'category',
        data: [],
        boundaryGap: true,
        axisLine: {
            lineStyle: {
                color: '#B4B4B4'
            }
        },
        axisTick: {
            show: false
        }
    }],
    yAxis: [{
        name: '',
        nameTextStyle: {
            color: '#959595'
        },
        splitLine: {
            show: true,
            lineStyle: {
                type: 'dashed',
                color: ["rgba(255,255,255,0.2)"],
            }
        },
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            textStyle: {
                color: '#959595'
            },
        }
    },
    {
        name: '',
        nameTextStyle: {
            color: '#959595'
        },
        splitLine: {
            show: false
        },
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            textStyle: {
                color: '#959595'
            },
            formatter: '{value} '
        }
    },
    ],
    series: [
        {
            name: '观看人数',
            type: 'bar',
            barWidth: 10,
            yAxisIndex: 1,
            itemStyle: {
                normal: {
                    color: '#8BAFFE',
                    borderWidth: 2,
                    //柱状图圆角
                    barBorderRadius: [4, 4, 0, 0],
                }
            },

            data: []
        },
        {
            name: '总互动量',
            type: 'line',
            smooth: true,
            showSymbol: true,
            symbolSize: 2,
            yAxisIndex: 0,
            areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: 'rgba(250,180,101,0.3)'
                    },
                    {
                        offset: 1,
                        color: 'rgba(250,180,101,0)'
                    }
                    ]),
                    shadowColor: 'rgba(250,180,101,0.2)',
                    shadowBlur: 20
                }
            },
            itemStyle: {
                normal: {
                    color: '#FFC05C'
                }
            },
            // data中可以使用对象，value代表相应的值，另外可加入自定义的属性
            data: []
        }
    ]
};

export default option